/** La fel ca ClientApp2 `src/utils/general.ts`. */
export const removeDiacritics = (val?: string | null): string =>
  (val || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const normalizePostalCode = (postalCode?: string) => {
  const normalizedPostalCode = String(postalCode ?? '').trim();
  const hasSupportedSeparators = /^[\d\s.-]+$/.test(normalizedPostalCode);
  const digitsOnlyPostalCode = normalizedPostalCode.replace(/\D/g, '');

  if (hasSupportedSeparators && digitsOnlyPostalCode.length === 5) {
    return `0${digitsOnlyPostalCode}`;
  }

  return normalizedPostalCode;
};

export const isCuiDigitsOnly = (companyNumber?: string | null | undefined): boolean => {
  const s = String(companyNumber ?? '').trim();
  return s.length > 0 && /^\d+$/.test(s);
};

export const hasRight = (user: any, right: string): boolean =>
  user?.profile?.role?.includes(right) ?? false;
